import installElementIcon from './icon';
import 'element-plus/es/components/loading/style/index';
import 'element-plus/theme-chalk/el-loading.css';
import 'element-plus/theme-chalk/el-message.css';
import 'element-plus/theme-chalk/el-notification.css';
import 'element-plus/theme-chalk/el-message-box.css';
import './theme.scss';
export default (app => {
  installElementIcon(app);
});